import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useSearchParams } from 'next/navigation';
import { PAGES } from '../../context/MagicSvgContext/magicSvgReducer';
import Landing from './pages/landing';
import Generate from './pages/generate';
import Result from './pages/result';

export default function MagicSvg({ builderState }) {
  const artStylesProxy = builderState?.state?.artStyles;
  const artStyles = JSON.parse(JSON.stringify(artStylesProxy));
  const search = useSearchParams();
  const page = search.get('page') || PAGES.LANDING;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const currentView = () => {
    switch (page) {
      case PAGES.LANDING:
        return <Landing />;
      case PAGES.GENERATE:
        return <Generate artStyles={artStyles} />;
      case PAGES.RESULT:
        return <Result />;
      default:
        return <Landing />;
    }
  };

  return (
    <Grid
      container
      alignItems='center'
      flexDirection='column'>
      {currentView()}
    </Grid>
  );
};

MagicSvg.propTypes = {
  builderState: PropTypes.shape({
    state: PropTypes.shape({
      artStyles: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          imageUrl: PropTypes.string,
          label: PropTypes.string,
        }),
      ),
    }),
  }).isRequired,
};

MagicSvg.defaultProps = {};
